module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="story-links">\n  <h3>Stories</h4>\n  <ul id="story_list"></ul>\n</div>';
}
return __p;
};
